module.exports = __webpack_public_path__ + "static/media/modal3.67a187cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/modal3.png
// module id = 1359
// module chunks = 0